<template>
  <div class="series-picker">
    <div class="series-picker-action" :class="{'with-placeholder': !value, readonly}" :style="{'line-height': !!actionHeight}" @click="toggleModal()">
      <span>{{seriesName || placeholder}}</span>
      <div v-if="!readonly" class="ico-box"><img :style="{ transform: `rotate(${iconRotate})`}" src="../../../../assets/images/btn_next@2x.png" /></div>
    </div>
    <div class="series-picker-modal" v-if="showModal">
      <div class="series-picker-modal-mask" @click="toggleModal()" />
      <div class="series-picker-modal-content" :style="{ height: pickerHeight || '90vh' }">
        <div class="series-picker-modal-header">
          <span>{{title}}</span>
        </div>
        <div class="series-list">
          <template v-for="item of options">
            <div class="series-item" @click="handleSelectSeries(item)" v-if="!item.invisible" :key="item.value">
              <img class="series-item__avatar" :src="item.avatar" />
              <span class="series-item__label">{{item.label}}</span>
              <img v-if="item.value === value" class="series-item__checked" src="https://cdn-app.nio.com/BEYONDER/2020/11/9/864df262-3c6d-42f6-9cda-c9e792e917ec.png" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stopBodyScroll } from '@/util/dom';

export default {
    name: 'series-picker',
    componentName: 'seriesPicker',
    props: {
        // 展示选中文案位置
        actionHeight: {
            type: String,
            default: ''
        },
        pickerHeight: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            default: () => {
                return [];
            }
        },
        iconPosition: {
            type: String,
            default: 'bottom'
        },
        readonly: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '请选择试驾车型'
        },
        placeholder: {
            type: String,
            default: '请选择试驾车型'
        }
    },
    data() {
        return {
            showModal: false
        };
    },
    methods: {
        toggleModal() {
            if (this.readonly) {
                return;
            }
            stopBodyScroll(!this.showModal);
            this.showModal = !this.showModal;
        },
        handleSelectSeries(series) {
            this.showModal = false;
            stopBodyScroll(false);
            this.$emit('onChange', series.value);
        }
    },
    computed: {
        iconRotate() {
            if (this.iconPosition === 'right') {
                return '-90deg';
            }
            return '0';
        },
        seriesName() {
            const item = this.options.find(i => i.value === this.value);
            return (item && (item.codeName || item.code)) || this.value;
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';
.ico-box {
    width: 20 * @layout375;
    margin-left: 5 * @layout375;
    text-align: right;
    display: flex;
    align-items: center;
    img {
        width: 90%;
    }
}

.series-picker-modal {
  display: block;
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.4);
  width: 100%;
  height: 100%;
  animation: 0.3s fadeIn;
}
.series-picker-modal-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.series-picker-modal-content {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 90vh;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 20 * @layout375 20 * @layout375 0 0;
  display: flex;
  flex-direction: column;
}
.series-picker-modal-header {
  padding: 38 * @layout375 25 * @layout375 20 * @layout375;
  font-size: 30 * @layout375;
  color: #363C54;
}
.series-picker {
  display: block;
  width: 100%;
}

.series-picker-action {
  width: 100%;
  color: #363C54;
  font-size: 16 * @layout375;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    flex: 1;
  }
}
.series-picker-action > span {
  flex: 1;
}
.series-picker-action.readonly > span {
  text-align: right;
}
.with-placeholder {
  color: #CDCED4;
}
.series-list {
  flex: 1;
  padding: 0 20 * @layout375;
  overflow: auto;
}
.series-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 9 * @layout375 0;
}
.series-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5 * @layout375;
  right: 5 * @layout375;
  background-color: #F5F5F5;
  height: 1 * @layout375;
}
.series-item:first-child::before {
  content: '';
  position: absolute;
  top: 0;
  left: 5 * @layout375;
  right: 5 * @layout375;
  background-color: #F5F5F5;
  height: 1 * @layout375;
}
.series-item__avatar {
  width: 140 * @layout375;
  height: 82 * @layout375;
  margin-right: 2 * @layout375;
}
.series-item__label {
  font-size: 18 * @layout375;
  color: #363C54;
}
.series-item__checked {
  position: absolute;
  right: 10 * @layout375;
  top: 50%;
  width: 20 * @layout375;
  height: 20 * @layout375;
  margin-top: -10 * @layout375;
}
.readonly > span {
  text-align: right;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>




// WEBPACK FOOTER //
// src/marketing_components/form/picker/series-picker/index.vue